import { useState, useMemo, useEffect } from "react";
import styled from "@emotion/styled";
import { useFormData } from "../../../contexts/FormData";

import { useFormikContext } from "formik";

import { useQuery } from "@tanstack/react-query";

import { getConsignedByVendor } from "../apiService";

import { BasicFlex, ScrollableContainer, InputLabel } from "../../../utils/Common";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import { IconButton, lighten, darken, Box } from "@mui/material";

import {
  RadioButtonUnchecked as UnselectedIcon,
  CheckCircle as SelectedIcon,
} from '@mui/icons-material';

import CloseRounded from '@mui/icons-material/CloseRounded';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';

import SearchInput from "../../../utils/utilities/SearchInput";

import WigItem from "../../Inventory/Components/WigItem";

import { formatCurrency } from "../../../utils/util";

const Container = styled(ScrollableContainer)`
  width: 90rem;
  padding: 0 .8rem;
  /* margin-bottom: 6rem; */
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  input {
    cursor: pointer;
  }
`;

const Row = styled(BasicFlex)`
  gap: 1rem;
  /* margin-bottom: 1rem; */
  /* border-bottom: 1px solid ${props => props.theme.colors.border}; */
  border-radius: 5px;
  background-color: white;
  margin: .8rem 0;
  padding: 1rem 1.5rem;
  cursor: pointer;
`;

const RowItem = styled.div`
  padding: .5rem;
`

const Sku = styled.div`

`

const Amount = styled.div`
  font-weight: 500;
  font-size: 1.5rem;
`

const Pill = styled.div`
  border-radius: 10px;
  padding: .2rem 1rem;
  background-color: ${props => props.$color ? lighten(props.theme.colors.success, .8) : props.theme.colors.darkBg};
  color: ${props => props.$color ? darken(props.theme.colors.success, .8) : "inherit"};
  font-weight: 500;
  font-size: 1rem;
  width: max-content;
`

const RetailPill = ({ price, cost }) => {
  return ( price ?
    <Pill $color={true}>
      ${price} &middot; +{((price - cost) / cost * 100).toFixed(0)}%
    </Pill>
    : <Pill>No Retail Set</Pill>
  )
}


const SelectionIcon = ({ selected }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      color: selected ? 'success.main' : 'text.disabled',
      transition: 'color 120ms',
      '&:hover': {
        color: selected ? 'success.dark' : 'text.secondary',
      },
    }}
  >
    {selected ? <SelectedIcon /> : <UnselectedIcon />}
  </Box>
);


const ConsignedList = () => {
  const { values } = useFormikContext() || {};

  const { formValues, setFormValues } = useFormData() || {};

  const { data: consigned } = useQuery({
    queryKey: ["consigned", values?.vendor_id],
    queryFn: () => getConsignedByVendor(values?.vendor_id),
    enabled: !!values?.vendor_id,
  });

  return ( values?.vendor_id && consigned?.length ?
    <BasicFlex dir="column">
      <InputLabel>Found {consigned?.length} consigned wigs · 0 selected</InputLabel>
      <Container $height="30rem">
        {consigned?.map(el => {
          return (
          <Row key={el.inventory_id}>
            <BasicFlex justify="flex-start" gap="2rem">
              <RowItem>
                <SelectionIcon selected={true} />
              </RowItem>

              <BasicFlex>

                <BasicFlex dir="column">
                  <WigItem wig_id={el.wig_id} sku={el.sku} trunc={false} />
                </BasicFlex>

              <BasicFlex width="auto" dir="column" align="flex-end" gap=".5rem">
                <Amount>{formatCurrency(el.cost)}</Amount>
                <RetailPill price={el.price} cost={el.cost} />
              </BasicFlex>

              </BasicFlex>
            </BasicFlex>
          </Row>
        )})}
      </Container>
      
    </BasicFlex> : null
  ) 
};

export default ConsignedList;